import { createApiRef } from '@backstage/core-plugin-api';
import fetch from 'cross-fetch';
import qs from 'qs';

const stackOverflowApiRef = createApiRef({
  id: "plugin.stackoverflow.service"
});

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class StackOverflowClient {
  constructor({ baseUrl }) {
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
  }
  static fromConfig(config) {
    return new StackOverflowClient({
      baseUrl: config.getOptionalString("stackoverflow.baseUrl") || "https://api.stackexchange.com/2.2"
    });
  }
  /**
   * List questions in the StackOverflow instance
   */
  async listQuestions(options) {
    const params = qs.stringify(options.requestParams, {
      addQueryPrefix: true,
      arrayFormat: "repeat"
    });
    const response = await fetch(`${this.baseUrl}/questions${params}`);
    const data = await response.json();
    return data.items;
  }
}

export { StackOverflowClient as S, stackOverflowApiRef as s };
//# sourceMappingURL=StackOverflowClient-bbc10006.esm.js.map
